<div class="nota-tipo" [formGroup]="notaForm">
	<div class="nota-tipo__header">
		<div>
			<div class="nota-tipo__eyebrow">Tipo de nota</div>
			<div class="nota-tipo__description">Seleccione el tipo de corrección que aplicará al documento.</div>
		</div>
	</div>
	<div class="nota-tipo__options">
		<!-- Opciones para Nota de Crédito (61) -->
		<div *ngIf="codigoTipoDte === 61">
			<label class="nota-tipo__option" [class.is-selected]="selectedTipoNota === 'Anulación'" for="anulacion">
				<input type="radio" id="anulacion" name="tipoNota" [checked]="selectedTipoNota === 'Anulación'" (change)="onChangeTipoNota('Anulación')" />
				<span>Anulación</span>
			</label>
			<label class="nota-tipo__option" [class.is-selected]="selectedTipoNota === 'Corrección Monto'" for="correccionMonto">
				<input type="radio" id="correccionMonto" name="tipoNota" [checked]="selectedTipoNota === 'Corrección Monto'" (change)="onChangeTipoNota('Corrección Monto')" />
				<span>Corrección de monto</span>
			</label>
			<label class="nota-tipo__option" [class.is-selected]="selectedTipoNota === 'Corrección Texto'" for="correccionTexto">
				<input type="radio" id="correccionTexto" name="tipoNota" [checked]="selectedTipoNota === 'Corrección Texto'" (change)="onChangeTipoNota('Corrección Texto')" />
				<span>Corrección de texto</span>
			</label>
		</div>
		<div *ngIf="codigoTipoDte === 56">
			<label class="nota-tipo__option" [class.is-selected]="selectedTipoNota === 'Intereses'" for="intereses">
				<input type="radio" id="intereses" name="tipoNota" [checked]="selectedTipoNota === 'Intereses'" (change)="onChangeTipoNota('Intereses')" />
				<span>Intereses</span>
			</label>
			<label class="nota-tipo__option" [class.is-selected]="selectedTipoNota === 'Anulación'" for="anulacion">
				<input type="radio" id="anulacion" name="tipoNota" [checked]="selectedTipoNota === 'Anulación'" (change)="onChangeTipoNota('Anulación')" />
				<span>Anulación</span>
			</label>
		</div>
	</div>
		<!-- Corrección Texto -->
		<div class="nota-tipo__section" *ngIf="selectedTipoNota === 'Corrección Texto'">
			<label class="nota-tipo__label" for="itemsCorreccion">Descripción de corrección</label>
					<input
						name="itemsCorreccion"
						id="itemsCorreccion"
						formControlName="itemsCorreccion"
						class="form-control"
						style="resize: none"
						[ngClass]="{
							'is-invalid': notaForm.get('motivo').invalid && (notaForm.get('motivo').touched || notaForm.get('motivo').dirty)
						}"
					/>
			<small class="form-text text-muted">Especifique el texto que cambia; por ejemplo: DONDE DICE “XXX” DEBE DECIR “YYY”.</small>
		</div>
		<!-- Motivo -->
		<div class="nota-tipo__section nota-tipo__motivo">
			<p class="nota-tipo__notice">Nota: estos datos son de uso interno y no se reflejan en el documento.</p>
			<div class="nota-tipo__motivo-field">
				<label class="nota-tipo__label" for="motivo">Motivo</label>
				<ng-container *ngIf="!isSingleMotivo; else singleMotivo">
					<ng-select
						[items]="motivosParaMostrar"
						bindLabel="label"
						bindValue="value"
						placeholder="Seleccione Motivo"
						formControlName="motivo"
						[clearable]="false"
						(change)="onChangeMotivo($event)"
						[ngClass]="{
							'is-invalid': notaForm.get('motivo').invalid && (notaForm.get('motivo').touched || notaForm.get('motivo').dirty)
						}"
					>
					</ng-select>
					<div *ngIf="notaForm.get('motivo').invalid && (notaForm.get('motivo').touched || notaForm.get('motivo').dirty)" class="invalid-feedback d-block">
						<div *ngIf="notaForm.get('motivo').errors?.required">Campo requerido</div>
					</div>
				</ng-container>
				<ng-template #singleMotivo>
					<input type="text" class="form-control" [value]="motivosParaMostrar[0]" disabled />
				</ng-template>
			</div>
		</div>
</div>
